/**
 * Returns list "Create RMA" action: navigates to the RMS create-RMA flow by default, or opens the merchant
 */
import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../../../components/inputs/button/button";
import { BUTTON_VARIANTS } from "../../../../components/inputs/button-variants";
import ResolveCapability from "../../../../components/resolve-capability/resolve-capability";
import { PROFILE_CAPABILITIES } from "../../../../models/ProfileCapabilities";
import {
    ManageReturnsDesignVersion,
    trackManageReturnsListEvent,
} from "../../utils/manage-returns-list-mixpanel";
import "./create-rma-list-action.scss";

interface IProps {
    getCreateRmaLabel: () => string;
    designVersion: ManageReturnsDesignVersion;
}

const CreateRmaListAction: React.FC<IProps> = observer(({ getCreateRmaLabel, designVersion }) => {
    const navigate = useNavigate();

    const navigateToCreateRmaPage = () => {
        trackManageReturnsListEvent("d&_create_rma", designVersion);
        navigate({ pathname: "/create-rma" });
    };

    return (
        <ResolveCapability capability={PROFILE_CAPABILITIES.INTERNAL_RMA_CREATION}>
            {({ isEnabled }) =>
                isEnabled && (
                    <div className="create-rma-list-action">
                        <Button
	                            variant={BUTTON_VARIANTS.PrimaryAccent}
	                            text={getCreateRmaLabel()}
	                            onClick={navigateToCreateRmaPage}
	                    />
                    </div>
                )
            }
        </ResolveCapability>
    );
});

export default CreateRmaListAction;
